import type { CancelToken, Method } from 'axios';
import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import { nanoid } from 'nanoid';
import config from '../../config';
import logger from './logging/logger';

export const API_BASE_URL = config.api.base_url;

const IGNORE_RESET_AUTH_ENDPOINTS = ['/auth/login', '/auth/register'];

let onUnauthorized: () => void | undefined;

export const setOnUnauthorized = (newOnUnauthorized: () => void): void => {
    onUnauthorized = newOnUnauthorized;
};
// eslint-disable-next-line max-params
export async function apiFetch<T>(
    endpoint: string,
    params?: Record<string, $TSFixMe> | null,
    method: Method = 'get',
    fullResponse?: boolean,
    cancelToken?: CancelToken
): Promise<T> {
    const shouldResetAuth = !IGNORE_RESET_AUTH_ENDPOINTS.includes(endpoint);
    try {
        const response = await axios({
            headers: {
                'X-Transaction-ID': nanoid()
            },
            method,
            url: API_BASE_URL + endpoint,
            data: params,
            withCredentials: true,
            cancelToken
        });
        return fullResponse ? response : response.data;
    } catch (err: $TSFixMe) {
        if (err.response && err.response.status === 401 && shouldResetAuth) {
            // in case any request has failed because of 401 - unlogin the user but not for login request
            onUnauthorized?.();
        }

        if (!axios.isCancel(err)) {
            // do not log cancelled requests as errors
            const error = err.response || err;
            logger.error('Api Fetch Error', { error });

            Bugsnag.notify(err, (event) => {
                event.addMetadata('extra', { method, endpoint });
            });
        }

        throw err;
    }
}
